import type { I18nFn } from 'i18n/types/I18nFn';
import { sort } from 'utils/functional/array';

function UNSORTED_COUNTRIES(i18n: I18nFn) {
  return [
    {
      id: 'AF',
      name: i18n('Afghanistan'),
    },
    {
      id: 'AX',
      name: i18n('Åland'),
    },
    {
      id: 'AL',
      name: i18n('Albania'),
    },
    {
      id: 'DZ',
      name: i18n('Algeria'),
    },
    {
      id: 'AS',
      name: i18n('American Samoa'),
    },
    {
      id: 'AD',
      name: i18n('Andorra'),
    },
    {
      id: 'AO',
      name: i18n('Angola'),
    },
    {
      id: 'AI',
      name: i18n('Anguilla'),
    },
    {
      id: 'AQ',
      name: i18n('Antarctica'),
    },
    {
      id: 'AG',
      name: i18n('Antigua and Barbuda'),
    },
    {
      id: 'AR',
      name: i18n('Argentina'),
    },
    {
      id: 'AM',
      name: i18n('Armenia'),
    },
    {
      id: 'AW',
      name: i18n('Aruba'),
    },
    {
      id: 'AU',
      name: i18n('Australia'),
    },
    {
      id: 'AT',
      name: i18n('Austria'),
    },
    {
      id: 'AZ',
      name: i18n('Azerbaijan'),
    },
    {
      id: 'BS',
      name: i18n('Bahamas'),
    },
    {
      id: 'BH',
      name: i18n('Bahrain'),
    },
    {
      id: 'BD',
      name: i18n('Bangladesh'),
    },
    {
      id: 'BB',
      name: i18n('Barbados'),
    },
    {
      id: 'BY',
      name: i18n('Belarus'),
    },
    {
      id: 'BE',
      name: i18n('Belgium'),
    },
    {
      id: 'BZ',
      name: i18n('Belize'),
    },
    {
      id: 'BJ',
      name: i18n('Benin'),
    },
    {
      id: 'BM',
      name: i18n('Bermuda'),
    },
    {
      id: 'BT',
      name: i18n('Bhutan'),
    },
    {
      id: 'BO',
      name: i18n('Bolivia'),
    },
    {
      id: 'BQ',
      name: i18n('Bonaire'),
    },
    {
      id: 'BA',
      name: i18n('Bosnia and Herzegovina'),
    },
    {
      id: 'BW',
      name: i18n('Botswana'),
    },
    {
      id: 'BV',
      name: i18n('Bouvet Island'),
    },
    {
      id: 'BR',
      name: i18n('Brazil'),
    },
    {
      id: 'IO',
      name: i18n('British Indian Ocean Territory'),
    },
    {
      id: 'VG',
      name: i18n('British Virgin Islands'),
    },
    {
      id: 'BN',
      name: i18n('Brunei'),
    },
    {
      id: 'BG',
      name: i18n('Bulgaria'),
    },
    {
      id: 'BF',
      name: i18n('Burkina Faso'),
    },
    {
      id: 'BI',
      name: i18n('Burundi'),
    },
    {
      id: 'KH',
      name: i18n('Cambodia'),
    },
    {
      id: 'CM',
      name: i18n('Cameroon'),
    },
    {
      id: 'CA',
      name: i18n('Canada'),
    },
    {
      id: 'CV',
      name: i18n('Cape Verde'),
    },
    {
      id: 'KY',
      name: i18n('Cayman Islands'),
    },
    {
      id: 'CF',
      name: i18n('Central African Republic'),
    },
    {
      id: 'TD',
      name: i18n('Chad'),
    },
    {
      id: 'CL',
      name: i18n('Chile'),
    },
    {
      id: 'CN',
      name: i18n('China'),
    },
    {
      id: 'CX',
      name: i18n('Christmas Island'),
    },
    {
      id: 'CC',
      name: i18n('Cocos [Keeling] Islands'),
    },
    {
      id: 'CO',
      name: i18n('Colombia'),
    },
    {
      id: 'KM',
      name: i18n('Comoros'),
    },
    {
      id: 'CK',
      name: i18n('Cook Islands'),
    },
    {
      id: 'CR',
      name: i18n('Costa Rica'),
    },
    {
      id: 'HR',
      name: i18n('Croatia'),
    },
    {
      id: 'CU',
      name: i18n('Cuba'),
    },
    {
      id: 'CW',
      name: i18n('Curacao'),
    },
    {
      id: 'CY',
      name: i18n('Cyprus'),
    },
    {
      id: 'CZ',
      name: i18n('Czechia'),
    },
    {
      id: 'CD',
      name: i18n('Democratic Republic of the Congo'),
    },
    {
      id: 'DK',
      name: i18n('Denmark'),
    },
    {
      id: 'DJ',
      name: i18n('Djibouti'),
    },
    {
      id: 'DM',
      name: i18n('Dominica'),
    },
    {
      id: 'DO',
      name: i18n('Dominican Republic'),
    },
    {
      id: 'TL',
      name: i18n('East Timor'),
    },
    {
      id: 'EC',
      name: i18n('Ecuador'),
    },
    {
      id: 'EG',
      name: i18n('Egypt'),
    },
    {
      id: 'SV',
      name: i18n('El Salvador'),
    },
    {
      id: 'GQ',
      name: i18n('Equatorial Guinea'),
    },
    {
      id: 'ER',
      name: i18n('Eritrea'),
    },
    {
      id: 'EE',
      name: i18n('Estonia'),
    },
    {
      id: 'ET',
      name: i18n('Ethiopia'),
    },
    {
      id: 'FK',
      name: i18n('Falkland Islands'),
    },
    {
      id: 'FO',
      name: i18n('Faroe Islands'),
    },
    {
      id: 'FJ',
      name: i18n('Fiji'),
    },
    {
      id: 'FI',
      name: i18n('Finland'),
    },
    {
      id: 'FR',
      name: i18n('France'),
    },
    {
      id: 'GF',
      name: i18n('French Guiana'),
    },
    {
      id: 'PF',
      name: i18n('French Polynesia'),
    },
    {
      id: 'TF',
      name: i18n('French Southern Territories'),
    },
    {
      id: 'GA',
      name: i18n('Gabon'),
    },
    {
      id: 'GM',
      name: i18n('Gambia'),
    },
    {
      id: 'GE',
      name: i18n('Georgia'),
    },
    {
      id: 'DE',
      name: i18n('Germany'),
    },
    {
      id: 'GH',
      name: i18n('Ghana'),
    },
    {
      id: 'GI',
      name: i18n('Gibraltar'),
    },
    {
      id: 'GR',
      name: i18n('Greece'),
    },
    {
      id: 'GL',
      name: i18n('Greenland'),
    },
    {
      id: 'GD',
      name: i18n('Grenada'),
    },
    {
      id: 'GP',
      name: i18n('Guadeloupe'),
    },
    {
      id: 'GU',
      name: i18n('Guam'),
    },
    {
      id: 'GT',
      name: i18n('Guatemala'),
    },
    {
      id: 'GG',
      name: i18n('Guernsey'),
    },
    {
      id: 'GN',
      name: i18n('Guinea'),
    },
    {
      id: 'GW',
      name: i18n('Guinea-Bissau'),
    },
    {
      id: 'GY',
      name: i18n('Guyana'),
    },
    {
      id: 'HT',
      name: i18n('Haiti'),
    },
    {
      id: 'HM',
      name: i18n('Heard Island and McDonald Islands'),
    },
    {
      id: 'HN',
      name: i18n('Honduras'),
    },
    {
      id: 'HK',
      name: i18n('Hong Kong'),
    },
    {
      id: 'HU',
      name: i18n('Hungary'),
    },
    {
      id: 'IS',
      name: i18n('Iceland'),
    },
    {
      id: 'IN',
      name: i18n('India'),
    },
    {
      id: 'ID',
      name: i18n('Indonesia'),
    },
    {
      id: 'IR',
      name: i18n('Iran'),
    },
    {
      id: 'IQ',
      name: i18n('Iraq'),
    },
    {
      id: 'IE',
      name: i18n('Ireland'),
    },
    {
      id: 'IM',
      name: i18n('Isle of Man'),
    },
    {
      id: 'IL',
      name: i18n('Israel'),
    },
    {
      id: 'IT',
      name: i18n('Italy'),
    },
    {
      id: 'CI',
      name: i18n('Ivory Coast'),
    },
    {
      id: 'JM',
      name: i18n('Jamaica'),
    },
    {
      id: 'JP',
      name: i18n('Japan'),
    },
    {
      id: 'JE',
      name: i18n('Jersey'),
    },
    {
      id: 'JO',
      name: i18n('Jordan'),
    },
    {
      id: 'KZ',
      name: i18n('Kazakhstan'),
    },
    {
      id: 'KE',
      name: i18n('Kenya'),
    },
    {
      id: 'KI',
      name: i18n('Kiribati'),
    },
    {
      id: 'XK',
      name: i18n('Kosovo'),
    },
    {
      id: 'KW',
      name: i18n('Kuwait'),
    },
    {
      id: 'KG',
      name: i18n('Kyrgyzstan'),
    },
    {
      id: 'LA',
      name: i18n('Laos'),
    },
    {
      id: 'LV',
      name: i18n('Latvia'),
    },
    {
      id: 'LB',
      name: i18n('Lebanon'),
    },
    {
      id: 'LS',
      name: i18n('Lesotho'),
    },
    {
      id: 'LR',
      name: i18n('Liberia'),
    },
    {
      id: 'LY',
      name: i18n('Libya'),
    },
    {
      id: 'LI',
      name: i18n('Liechtenstein'),
    },
    {
      id: 'LT',
      name: i18n('Lithuania'),
    },
    {
      id: 'LU',
      name: i18n('Luxembourg'),
    },
    {
      id: 'MO',
      name: i18n('Macao'),
    },
    {
      id: 'MK',
      name: i18n('Macedonia'),
    },
    {
      id: 'MG',
      name: i18n('Madagascar'),
    },
    {
      id: 'MW',
      name: i18n('Malawi'),
    },
    {
      id: 'MY',
      name: i18n('Malaysia'),
    },
    {
      id: 'MV',
      name: i18n('Maldives'),
    },
    {
      id: 'ML',
      name: i18n('Mali'),
    },
    {
      id: 'MT',
      name: i18n('Malta'),
    },
    {
      id: 'MH',
      name: i18n('Marshall Islands'),
    },
    {
      id: 'MQ',
      name: i18n('Martinique'),
    },
    {
      id: 'MR',
      name: i18n('Mauritania'),
    },
    {
      id: 'MU',
      name: i18n('Mauritius'),
    },
    {
      id: 'YT',
      name: i18n('Mayotte'),
    },
    {
      id: 'MX',
      name: i18n('Mexico'),
    },
    {
      id: 'FM',
      name: i18n('Micronesia'),
    },
    {
      id: 'MD',
      name: i18n('Moldova'),
    },
    {
      id: 'MC',
      name: i18n('Monaco'),
    },
    {
      id: 'MN',
      name: i18n('Mongolia'),
    },
    {
      id: 'ME',
      name: i18n('Montenegro'),
    },
    {
      id: 'MS',
      name: i18n('Montserrat'),
    },
    {
      id: 'MA',
      name: i18n('Morocco'),
    },
    {
      id: 'MZ',
      name: i18n('Mozambique'),
    },
    {
      id: 'MM',
      name: i18n('Myanmar [Burma]'),
    },
    {
      id: 'NA',
      name: i18n('Namibia'),
    },
    {
      id: 'NR',
      name: i18n('Nauru'),
    },
    {
      id: 'NP',
      name: i18n('Nepal'),
    },
    {
      id: 'NL',
      name: i18n('Netherlands'),
    },
    {
      id: 'NC',
      name: i18n('New Caledonia'),
    },
    {
      id: 'NZ',
      name: i18n('New Zealand'),
    },
    {
      id: 'NI',
      name: i18n('Nicaragua'),
    },
    {
      id: 'NE',
      name: i18n('Niger'),
    },
    {
      id: 'NG',
      name: i18n('Nigeria'),
    },
    {
      id: 'NU',
      name: i18n('Niue'),
    },
    {
      id: 'NF',
      name: i18n('Norfolk Island'),
    },
    {
      id: 'KP',
      name: i18n('North Korea'),
    },
    {
      id: 'MP',
      name: i18n('Northern Mariana Islands'),
    },
    {
      id: 'NO',
      name: i18n('Norway'),
    },
    {
      id: 'OM',
      name: i18n('Oman'),
    },
    {
      id: 'PK',
      name: i18n('Pakistan'),
    },
    {
      id: 'PW',
      name: i18n('Palau'),
    },
    {
      id: 'PS',
      name: i18n('Palestine'),
    },
    {
      id: 'PA',
      name: i18n('Panama'),
    },
    {
      id: 'PG',
      name: i18n('Papua New Guinea'),
    },
    {
      id: 'PY',
      name: i18n('Paraguay'),
    },
    {
      id: 'PE',
      name: i18n('Peru'),
    },
    {
      id: 'PH',
      name: i18n('Philippines'),
    },
    {
      id: 'PN',
      name: i18n('Pitcairn Islands'),
    },
    {
      id: 'PL',
      name: i18n('Poland'),
    },
    {
      id: 'PT',
      name: i18n('Portugal'),
    },
    {
      id: 'PR',
      name: i18n('Puerto Rico'),
    },
    {
      id: 'QA',
      name: i18n('Qatar'),
    },
    {
      id: 'CG',
      name: i18n('Republic of the Congo'),
    },
    {
      id: 'RE',
      name: i18n('Réunion'),
    },
    {
      id: 'RO',
      name: i18n('Romania'),
    },
    {
      id: 'RU',
      name: i18n('Russia'),
    },
    {
      id: 'RW',
      name: i18n('Rwanda'),
    },
    {
      id: 'BL',
      name: i18n('Saint Barthélemy'),
    },
    {
      id: 'SH',
      name: i18n('Saint Helena'),
    },
    {
      id: 'KN',
      name: i18n('Saint Kitts and Nevis'),
    },
    {
      id: 'LC',
      name: i18n('Saint Lucia'),
    },
    {
      id: 'MF',
      name: i18n('Saint Martin'),
    },
    {
      id: 'PM',
      name: i18n('Saint Pierre and Miquelon'),
    },
    {
      id: 'VC',
      name: i18n('Saint Vincent and the Grenadines'),
    },
    {
      id: 'WS',
      name: i18n('Samoa'),
    },
    {
      id: 'SM',
      name: i18n('San Marino'),
    },
    {
      id: 'ST',
      name: i18n('São Tomé and Príncipe'),
    },
    {
      id: 'SA',
      name: i18n('Saudi Arabia'),
    },
    {
      id: 'SN',
      name: i18n('Senegal'),
    },
    {
      id: 'RS',
      name: i18n('Serbia'),
    },
    {
      id: 'SC',
      name: i18n('Seychelles'),
    },
    {
      id: 'SL',
      name: i18n('Sierra Leone'),
    },
    {
      id: 'SG',
      name: i18n('Singapore'),
    },
    {
      id: 'SX',
      name: i18n('Sint Maarten'),
    },
    {
      id: 'SK',
      name: i18n('Slovakia'),
    },
    {
      id: 'SI',
      name: i18n('Slovenia'),
    },
    {
      id: 'SB',
      name: i18n('Solomon Islands'),
    },
    {
      id: 'SO',
      name: i18n('Somalia'),
    },
    {
      id: 'ZA',
      name: i18n('South Africa'),
    },
    {
      id: 'GS',
      name: i18n('South Georgia and the South Sandwich Islands'),
    },
    {
      id: 'KR',
      name: i18n('South Korea'),
    },
    {
      id: 'SS',
      name: i18n('South Sudan'),
    },
    {
      id: 'ES',
      name: i18n('Spain'),
    },
    {
      id: 'LK',
      name: i18n('Sri Lanka'),
    },
    {
      id: 'SD',
      name: i18n('Sudan'),
    },
    {
      id: 'SR',
      name: i18n('Suriname'),
    },
    {
      id: 'SJ',
      name: i18n('Svalbard and Jan Mayen'),
    },
    {
      id: 'SZ',
      name: i18n('Swaziland'),
    },
    {
      id: 'SE',
      name: i18n('Sweden'),
    },
    {
      id: 'CH',
      name: i18n('Switzerland'),
    },
    {
      id: 'SY',
      name: i18n('Syria'),
    },
    {
      id: 'TW',
      name: i18n('Taiwan'),
    },
    {
      id: 'TJ',
      name: i18n('Tajikistan'),
    },
    {
      id: 'TZ',
      name: i18n('Tanzania'),
    },
    {
      id: 'TH',
      name: i18n('Thailand'),
    },
    {
      id: 'TG',
      name: i18n('Togo'),
    },
    {
      id: 'TK',
      name: i18n('Tokelau'),
    },
    {
      id: 'TO',
      name: i18n('Tonga'),
    },
    {
      id: 'TT',
      name: i18n('Trinidad and Tobago'),
    },
    {
      id: 'TN',
      name: i18n('Tunisia'),
    },
    {
      id: 'TR',
      name: i18n('Turkey'),
    },
    {
      id: 'TM',
      name: i18n('Turkmenistan'),
    },
    {
      id: 'TC',
      name: i18n('Turks and Caicos Islands'),
    },
    {
      id: 'TV',
      name: i18n('Tuvalu'),
    },
    {
      id: 'UM',
      name: i18n('U.S. Minor Outlying Islands'),
    },
    {
      id: 'VI',
      name: i18n('U.S. Virgin Islands'),
    },
    {
      id: 'UG',
      name: i18n('Uganda'),
    },
    {
      id: 'UA',
      name: i18n('Ukraine'),
    },
    {
      id: 'AE',
      name: i18n('United Arab Emirates'),
    },
    {
      id: 'GB',
      name: i18n('United Kingdom'),
    },
    {
      id: 'US',
      name: i18n('United States'),
    },
    {
      id: 'UY',
      name: i18n('Uruguay'),
    },
    {
      id: 'UZ',
      name: i18n('Uzbekistan'),
    },
    {
      id: 'VU',
      name: i18n('Vanuatu'),
    },
    {
      id: 'VA',
      name: i18n('Vatican City'),
    },
    {
      id: 'VE',
      name: i18n('Venezuela'),
    },
    {
      id: 'VN',
      name: i18n('Vietnam'),
    },
    {
      id: 'WF',
      name: i18n('Wallis and Futuna'),
    },
    {
      id: 'EH',
      name: i18n('Western Sahara'),
    },
    {
      id: 'YE',
      name: i18n('Yemen'),
    },
    {
      id: 'ZM',
      name: i18n('Zambia'),
    },
    {
      id: 'ZW',
      name: i18n('Zimbabwe'),
    },
  ] as const satisfies { id: string; name: string }[];
}

export type CountryData = ReturnType<typeof UNSORTED_COUNTRIES>[number];

export function COUNTRIES(i18n: I18nFn): CountryData[] {
  return sort(UNSORTED_COUNTRIES(i18n), (a, b) =>
    a.name.localeCompare(b.name, CURRENT_LOCALE()),
  );
}

export function CountryNameById(
  i18n: I18nFn,
): Record<CountryData['id'], string> {
  return COUNTRIES(i18n).reduce(
    (acc, country) => ({
      ...acc,
      [country.id]: country.name,
    }),
    {} as unknown as Record<CountryData['id'], string>,
  );
}
